import { Routes } from '@angular/router';
import { BRANDING_SECTION_ROUTE_SEGMENTS } from './molecules/branding-section-registry/branding-section.registry';
import { Buttons } from './molecules/buttons/buttons';
import { Creatives } from './molecules/creatives/creatives';
import { Emails } from './molecules/emails/emails';

export const adminBrandingRoutes: Routes = [
  { path: '', redirectTo: BRANDING_SECTION_ROUTE_SEGMENTS.creatives, pathMatch: 'full' },
  { path: BRANDING_SECTION_ROUTE_SEGMENTS.creatives, component: Creatives },
  { path: BRANDING_SECTION_ROUTE_SEGMENTS.emails, component: Emails },
  { path: BRANDING_SECTION_ROUTE_SEGMENTS.buttons, component: Buttons },
];
